// src/pages/Lab/labTourConfig.js

import i18n from "../../../i18n/config";

export const labTourSteps = [
	  {
	    popover: {
	      title: i18n.t("tours.lab.welcome"),
	      description: i18n.t("tours.lab.welcomeDesc"),
	      side: "over",
	    },
	  },
	  {
	    element: 'input[placeholder*="Search"]',
	    popover: {
	      title: i18n.t("tours.lab.search"),
	      description: i18n.t("tours.lab.searchDesc"),
	      position: "bottom",
	    },
	  },
	  {
	    element: ".lab-list-scroll",
	    popover: {
	      title: i18n.t("tours.lab.list"),
	      description: i18n.t("tours.lab.listDesc"),
	      position: "top",
	    },
	  },
	  {
	    element: ".phc-row",
	    popover: {
	      title: i18n.t("tours.lab.card"),
	      description: i18n.t("tours.lab.cardDesc"),
	      position: "left",
	    },
	  },
	  {
	    popover: {
	      title: i18n.t("tours.lab.done"),
	      description: i18n.t("tours.lab.doneDesc"),
	      side: "over",
	    },
	  },
];